import { IDocumentProps } from '../../../props/general';
import Request from './../../request';

const SubsidiaryDocumentService = {
    retrieve: async (subsidiaryId: string, qs?: string):Promise<IDocumentProps[]> => {
        try {
            const results = await Request.get(`/api/subsidiaries/${subsidiaryId}/documents?${qs}`);
            return results;
        } catch(e) {
            throw(e);
        }
    },
    create: async (subsidiaryId: string, data: FormData):Promise<IDocumentProps> => {
        try {
            const result = await Request.post(`/api/subsidiaries/${subsidiaryId}/documents`, data, 'multipart/form-data');
            return result;
        } catch(e) {
            throw(e);
        }
    },
    update: async (subsidiaryId: string, data: FormData):Promise<IDocumentProps> => {
        try {
            const result = await Request.post(`/api/subsidiaries/${subsidiaryId}/documents?_method=PUT`, data, 'multipart/form-data');
            return result;
        } catch(e) {
            throw(e);
        }
    },
    delete: async (subsidiaryId: string, data: FormData): Promise<IDocumentProps> => {
        try {
            const result = await Request.post(`/api/subsidiaries/${subsidiaryId}/delete_documents`, data);
            return result;
        } catch (e) {
            throw (e);
        }
    }
}

export default SubsidiaryDocumentService;